import { render, staticRenderFns } from "./unfurled_link.vue?vue&type=template&id=0641de14&scoped=true&"
import script from "./unfurled_link.vue?vue&type=script&lang=js&"
export * from "./unfurled_link.vue?vue&type=script&lang=js&"
import style0 from "./unfurled_link.vue?vue&type=style&index=0&id=0641de14&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0641de14",
  null
  
)

export default component.exports